import { styled } from "../../../styles";

export const ViewTypeSelectorButton = styled("div", {
  // No right margin: the ward selector's own left margin provides the
  // standard 10px gap between the top bar pills.
  marginRight: "0",
  marginLeft: "10px",
  marginTop: "auto",
  marginBottom: "auto",
  padding: "0 5px 0 20px",

  width: "max-content",
  height: "37px",
  borderRadius: "20px",

  backgroundColor: "$gray-30",

  color: "$black",
  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "26px",
  textAlign: "center",
  textWrap: "nowrap",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",

  cursor: "pointer",

  border: "2px solid transparent",

  "&:hover": {
    backgroundColor: "$gray-40",
    border: "2px solid ",
    borderColor: "var(--colors-navbar-button-active-border) !important",
  },

  variants: {
    active: {
      true: {
        backgroundColor: "var(--colors-navbar-ward-select-active-background)",
        color: "var(--colors-navbar-ward-select-active-text)",

        svg: {
          path: {
            fill: "var(--colors-navbar-ward-select-active-icon) !important",
          },
        },

        "&:hover": {
          backgroundColor:
            "var(--colors-navbar-ward-select-active-hover) !important",
        },
      },
    },
  },
});

export const ViewTypeOptionsContainer = styled("div", {
  // Sized to its content so every option is visible without scrolling
  width: "fit-content",
  minWidth: "186px",
  height: "0px",
  overflow: "hidden",

  backgroundColor: "$white",
  borderRadius: "8px",

  // Aligned with the left edge of the view type pill
  position: "absolute",
  top: "54px",
  left: "0px",

  zIndex: "10",

  variants: {
    open: {
      true: {
        padding: "0 16px",
        border: "1px solid $gray-50",
        boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12)",
        height: "max-content",
        overflow: "visible",
      },
      false: {
        padding: "0px 16px",
        height: "0px",
        border: "none",
        boxShadow: "none",
      },
    },
  },
});

export const ViewTypeOption = styled("div", {
  width: "100%",
  padding: "14px 0",

  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "16px",
  textAlign: "left",

  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",

  color: "$gray-100 !important",
  borderBottom: "1px solid $gray-40",

  cursor: "pointer",

  variants: {
    selected: {
      true: {
        color:
          "var(--colors-navbar-ward-select-option-selected-text) !important",
      },
    },
  },
});

export const SavingOverlay = styled("div", {
  position: "fixed",
  inset: 0,
  // Above the top bar (zIndex 1100) so the whole page is blocked while saving
  zIndex: 2000,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  // Matches the patient page LoadingOverlay treatment (white, 0.64 opacity)
  backgroundColor: "rgba(255, 255, 255, 0.64)",

  ".ant-spin-dot .ant-spin-dot-item": {
    backgroundColor: "var(--colors-portal-loading-state-color)",
  },
});

export const ViewTypeOptionsFooter = styled("div", {
  width: "100%",
  maxWidth: "186px",
  padding: "14px 0",

  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "16px",
  textAlign: "left",
  textWrap: "wrap",

  color: "$gray-70",
});
